import { usePortfolioContext } from '../context/PortfolioContext'
import { Briefcase, ChevronDown } from 'lucide-react'

interface PortfolioSelectorProps {
  compact?: boolean
}

export default function PortfolioSelector({ compact }: PortfolioSelectorProps) {
  const { portfolios, selectedPortfolioId, setSelectedPortfolioId, isAgent, loading } = usePortfolioContext()

  // Only render for agents
  if (!isAgent) return null

  // Don't render if no portfolios exist yet
  if (!loading && portfolios.length === 0) return null

  return (
    <div
      className={`flex items-center gap-2 rounded-lg ${compact ? 'px-2 py-1.5' : 'px-3 py-1.5'}`}
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-color)',
      }}
    >
      <Briefcase className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--color-accent)' }} />
      <select
        value={selectedPortfolioId || ''}
        onChange={e => setSelectedPortfolioId(e.target.value || null)}
        className={`text-sm font-medium flex-1 appearance-none border-0 pr-5 ${compact ? 'max-w-[140px]' : 'min-w-[140px]'}`}
        style={{
          color: 'var(--text-primary)',
          background: 'transparent',
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          outline: 'none',
          cursor: 'pointer',
        }}
      >
        <option value="">All Portfolios</option>
        {portfolios.map(p => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
      <ChevronDown className="w-3.5 h-3.5 flex-shrink-0 pointer-events-none -ml-4" style={{ color: 'var(--text-muted)' }} />
    </div>
  )
}
